import API, { API_URL } from 'api/API';
import { ApiResult } from 'libs/types';

import { getUrlQueryString } from 'libs/utils';

interface GetLatestSkycamApiParams {
  obsId: number;
}

interface GetLatestSkycamApiResult extends ApiResult {
  skycam_path: string;
  last_update: {
    date: string;
    time: string;
  };
}

async function getLatestSkycamApi({ obsId }: GetLatestSkycamApiParams): Promise<GetLatestSkycamApiResult> {
  const queryString = getUrlQueryString({
    obs_id: obsId,
  });
  const { data } = await API.get(`${API_URL.SKYW.GET_LATEST_SKYCAM}?${queryString}`);

  return data;
}

export default getLatestSkycamApi;
